import { cva } from '@zenchef/styled-system/css'

export const modalFooterRecipe = cva({
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: 'gap.2',
    borderBottomRadius: { sm: 'xl' },
    textStyle: 'paragraph.s.regular',
    borderTop: 'm',
    zIndex: 1
  },
  variants: {
    fullscreen: {
      true: {
        borderBottomRadius: '0px'
      }
    },
    sdk: {
      true: { borderBottomRadius: 'xl' }
    },
    hierarchy: {
      bold: {
        bg: 'background.brand.bold',
        color: 'content.neutral-on-brand.subtlest',
        borderColor: 'border.neutral-on-brand.subtle'
      },
      subtle: {
        bg: 'background.neutral.base.subtlest',
        color: 'content.brand.subtlest',
        borderColor: 'border.brand-subtle'
      }
    }
  },
  defaultVariants: {
    hierarchy: 'bold'
  }
})

export const modalHeaderRecipe = cva({
  base: {
    display: 'flex',
    flexShrink: 0,
    zIndex: 3,
    justifyContent: 'space-between',
    alignItems: 'center',
    p: 'padding.1',
    gap: 'gap.1',
    backgroundColor: 'background.brand.bold',
    color: 'content.neutral-on-brand.bold',
    textStyle: 'title.xs',
    textTransform: 'uppercase',
    borderTopRadius: { sm: 'xl' },
    '& button': {
      _hover: {
        bg: 'none'
      }
    }
  },
  variants: {
    fullscreen: {
      true: {
        borderTopRadius: '0px'
      }
    },
    sdk: {
      true: { borderTopRadius: 'xl' }
    }
  }
})

export const modalHeaderItemRecipe = cva({
  base: {
    display: 'flex',
    gap: 'gap.2',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    width: '100%',
    color: 'content.neutral-on-brand.bold'
  },
  variants: {
    withBackButton: {
      true: {
        textAlign: 'left'
      },
      false: {
        pl: 'calc({sizes.3xl} + {spacing.padding.1})'
      }
    },
    withLogo: {
      false: {
        lineClamp: 2
      }
    },
    whiteLogo: {
      true: {
        filter: 'brightness(0) invert(1)'
      }
    }
  }
})
